import * as React from 'react';
const SvgLock = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 21" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.75 8.3c-.464 0-.91.18-1.237.498A1.676 1.676 0 003 10v6.8c0 .45.184.883.513 1.202.328.319.773.498 1.237.498h10.5c.464 0 .91-.18 1.237-.498.329-.319.513-.751.513-1.202V10c0-.45-.184-.883-.513-1.202A1.776 1.776 0 0015.25 8.3h-.583V6.033A4.469 4.469 0 0013.3 2.828 4.737 4.737 0 0010 1.5a4.737 4.737 0 00-3.3 1.328 4.469 4.469 0 00-1.367 3.205V8.3H4.75zm2.917-2.267c0-.6.245-1.177.683-1.602A2.369 2.369 0 0110 3.767c.619 0 1.212.238 1.65.664.438.425.683 1.001.683 1.602v2.264H7.667V6.033z"
            fill="currentColor"
        />
    </svg>
);
export default SvgLock;
